const hostname = window.location.hostname;
const isKnownDomain = ['gomeet.vnpt.vn', 'gomeeting.vnpt.vn', 'gomesainterb04.vnpt.vn'].includes(hostname);

const dev = {
  apiBaseUrl: isKnownDomain
    ? `https://${hostname}/api/v1`
    : "https://gomesainterk06.vnpt.vn/api/v1",
  appBaseUrl: "/app"
};

export default dev;